define('formkit/view/form/form.object.type.menu/form.object.type.menu.item.view',['require','exports','module','jquery','uikit/uikit','../../../templates'],function(require, exports, module) {
  var $         = require('jquery');
  var UIKit     = require('uikit/uikit');
  var Templates = require('../../../templates');

  var FormObjectMenuItemView = UIKit.ItemView.extend({
    template: Templates.App['form.object.type.menu.item'],

    className: 'form-object-type item',

    options: {
      form: null,
      disabled: false,
    },

    internalViewOptions: {
      formObjectButtonView: function() {
        return {
          type: UIKit.Button,
          text: this.form.getTemplateObjectTypeNameFromTypeModel(this.model),
          model: this.model,
          fluid: true,
          size: 'small',
          compact: true
        }
      }
    },

    internalViewBindings: {
      formObjectButtonView: {
        disabled: 'disabled'
      }
    },

    initialize: function() {
      UIKit.ItemView.prototype.initialize.apply(this, arguments);

      this.updateDisabledOptionFromMaxMultiplicity();

      this.listenTo(this.form, 'modify:template', function() {
        this.updateDisabledOptionFromMaxMultiplicity();
      });
    },

    updateDisabledOptionFromMaxMultiplicity: function() {
      this.disabled = this.form.maxMultiplicityReached(this.model);
    },

    onFormObjectButtonViewPress: function(buttonView) {
      $("body").animate({ scrollTop: $(document).height() }, 500);

      var lastIndex = this.form.util.lastChildIndex(this.form.getActiveSectionModel());
      this.form.insertTemplateObject(this.form.getActiveSectionModel(), {
        type: buttonView.model,
      }, lastIndex + 1);
    },

    updateAttributes: function(){
      this.addClass('disabled', this.getBoolOption('disabled'));
    }
  });

  module.exports = FormObjectMenuItemView;

});

